import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import { filterToProductType } from '@ve/services/productTypeConverter';

@extendDecorator({
    computeds: {
        minPriceTourOffer: {
            deps: ['syncTourProducts'],
            get(tourProducts) {
                return this.findMinPriceProduct(tourProducts, 'tourOffer');
            },
        },
        minPriceHotelOffer: {
            deps: ['syncTourProducts'],
            get(tourProducts) {
                return this.findMinPriceProduct(tourProducts, 'hotelOffer');
            },
        },
        minPriceRailway: {
            deps: ['syncTourProducts'],
            get(tourProducts) {
                return this.findMinPriceProduct(tourProducts, 'railwayTour');
            },
        },
    },
})
export default class HotelPageModel extends Backbone.Epoxy.Model {
    findMinPriceProduct(tourProducts, type) {
        if (!tourProducts?.length) {
            return false;
        }

        const filteredProducts = this.filterTourProductsByProductTypeWithTourPriority(tourProducts.models, type);

        if (!filteredProducts.length) {
            return false;
        }

        const minPriceProduct = _.min(filteredProducts.models, (tourProduct) => tourProduct?.get('product')?.get('priceWithOilTax')
            ?? tourProduct?.get('product')?.get('price'));

        return minPriceProduct === Infinity
            ? false
            : minPriceProduct;
    }

    filterTourProductsByProductTypeWithTourPriority(tourProducts, selectedProductType) {
        return new Backbone.Collection(selectedProductType === 'all' ? tourProducts.models : tourProducts.filter((product) => product.get('type') === filterToProductType(selectedProductType)));
    }
}
